<template>
  <div>
    <el-popover
        width="350px"
        title="Undelegated Stake"
        v-if="(!account.account.data.parsed.info.stake) || (account.account?.data?.parsed?.info?.stake?.delegation?.deactivationEpoch < epochInfo.epoch)"
        >
      This stake is undelegated and earning no rewards. You should either delegate it to a validator to start earning rewards, or withdraw it to your account.
      <template #reference>
        <div class="badge bg-danger text-white">Undelegated</div>
      </template>
    </el-popover>
    <el-popover
        width="350px"
        title="Deactivating Stake"
        v-else-if="(account.account.data.parsed.info.stake.delegation.deactivationEpoch == epochInfo.epoch)"
        >
        This stake is deactivating. It will stop earning rewards and become available to withdraw at the end of this epoch
      <template #reference>
        <div class="badge bg-warning text-white">Deactivating</div>
      </template>
    </el-popover>
    <el-popover
        width="350px"
        title="Activating Stake"
      v-else-if="account.account.data.parsed.info.stake.delegation.activationEpoch == epochInfo.epoch"
      >
      This stake is delegated and activating. It will become active at the end of the current epoch, and earn its first rewards at the end of epoch {{ epochInfo.epoch + 1 }}
      <template #reference>
        <div class="badge bg-info text-white">Activating</div>
      </template>
    </el-popover>
    <el-popover
        width="350px"
        title="Missing Stake Rewards"
      v-else-if="(parseInt(account.account.lamports) - (parseInt(account.account.data.parsed.info.stake.delegation.stake) + parseInt(account.account.data.parsed.info.meta.rentExemptReserve))) > (.05*1e9)"
      >
      <p>There are {{ (parseInt(account.account.lamports) - (parseInt(account.account.data.parsed.info.stake.delegation.stake) + parseInt(account.account.data.parsed.info.meta.rentExemptReserve)))/1e9 }} inactive SOL in this account that are currently earning no staking rewards.</p>
      <p>This usually occurs when extra SOL is transferred to an existing, activated stake account. As the new SOL was never 'activated' it currently earns zero rewards.</p>
      <p>To start earning rewards, first withdraw the excess SOL and then create + delegate a new stake account.</p>
      <template #reference>
        <div class="badge bg-warning text-white">Missing Rewards</div>
      </template>
    </el-popover>
    <el-popover
      width="350px"
      v-else-if="(validator.stake_concentration_score || 0) < 0"
      title="Excessive Stake Concentration">
      <p>This validator is among the 'halt line' or 'security group' of validators - a small group of 25 validators that have the power to halt the Solana network should they collaborate or be exploited, due to having an excessive share of the network's stake.</p>
      <p>To help protect your investment in Solana, aiding decentralization and censorship resistance, you should stake with smaller validators.</p>
      <p>To move your stake you must first unstake. Then, at the end of the epoch you may redelegate the stake to a different validator.</p>
      <template #reference>
        <div class="badge bg-danger text-white">Excess Stake</div>
      </template>

    </el-popover>
    <el-popover
        width="350px"
        v-else-if="validator.delinquent || false"
        title="Validator Offline">
      <p>This validator is offline and not producing rewards.</p>
      <p>It is acceptable for a validator to be offline for a period of 10-15 minutes for regular upgrades, and up to a couple of hours in the event of a serious hardware or network failure.</p>
      <p>Frequent or prolonged delinquencies are a serious issue, hurting stakers who receive zero rewards, and the Solana network as a whole</p>
      <p>If your validator is frequently delinquent, please move your stake elsewhere.</p>
      <template #reference>
        <div class="badge bg-danger text-white">Offline</div>
      </template>
    </el-popover>
    <el-popover
        width="350px"
        v-else-if="(validator.commission || 0) > 10"
        title="High Commission">
      <p>This validator is charging an excessively high commission of {{ validator.commission }}%</p>
      <p>This means you will receive low - or no - rewards compared to fairer validators. You should unstake and re-delegate to a validator with a more realistic commission.</p>
      <p>We currently alert on any validator that charges over 10%</p>
      <template #reference>
        <div class="badge bg-danger text-white">High Commission</div>
      </template>
    </el-popover>

    <el-popover
      width="350px"
      v-else-if="(validator.data_center_concentration_score || 0) < -1"
      title="Validator in an overpopulated datacenter">
      <p>This validator is located in a datacenter or geographic location that has an excessively high concentration of stake.</p>
      <p>This means in the event of a network or power outage, political unrest or natural disaster in the region the Solana network could be put at risk.</p>
      <p>To help protect your investment in Solana, aiding decentralization and censorship resistance, you should stake with smaller validators.</p>
      <p>To move your stake you must first unstake. Then, at the end of the epoch you may redelegate the stake to a different validator.</p>
      <template #reference>
        <div class="badge bg-warning text-white">Overpopulated DC</div>
      </template>
    </el-popover>
    <el-popover
        width="350px"
        title="Good Health"
      v-else>
      This stake account is in good health and is earning rewards.
      <template #reference>
        <div class="badge bg-success text-white">Good</div>
      </template>
    </el-popover>

  </div>
</template>

<script>
export default {
  name: "StakeHealth",
  props: ['account','validator', 'epochInfo']
}
</script>

<style scoped>
.el-popover.el-popper {
  text-align:left !important;
  word-break:break-word !important;
  font-size:90% !important;
}
</style>
